<ng-container>
  <div
    *ngIf="transformedSurveys.length"
    class="table-responsive multi-country-data-table"
  >
    <ps-ui-table
      [data]="transformedSurveys"
      [trackBy]="'ps_survey_id'"
      [disableHorizontalScrollingButtons]="true"
    >
      <ng-container psUiTableExpandableRow>
        <ng-container
          psUiTableColumn
          [sortable]="true"
          [truncateWord]="false"
          [field]="header.orderKey"
          [textAlignment]="'center'"
          title="{{ header.label }}"
          *ngFor="let header of getHeaders()"
        >
          <ng-template
            *ngIf="
              header.label ===
              constants.MC_SURVEY_TABLE_HEADERS.SURVEY_STATUS.label
            "
            psUiTableCellTemplate
            let-survey
          >
            <div class="survey-status">
              <button
                class="survey-status-btn dropdown-menu-btn"
                [psUiDropdownToggleFor]="surveysStatusDropdown"
                [class.action-disabled]="isSurveyStatusDropdownDisabled(survey)"
              >
                {{ surveyStatus[survey.ps_survey_status] }}
              </button>
              <ps-ui-dropdown
                class="survey-status-dropdown"
                #surveysStatusDropdown="psUiDropdown"
              >
                <div *ngFor="let statusButton of statusButtons">
                  <button
                    psUiDropdownItem
                    (click)="openStatusModal(survey, statusButton.value)"
                    *ngIf="
                      statusButton.condition.indexOf(survey.ps_survey_status) >
                      -1
                    "
                  >
                    {{ statusButton.value }}
                  </button>
                </div>
              </ps-ui-dropdown>
            </div>
          </ng-template>
          <ng-template
            *ngIf="
              header.label ===
              constants.MC_SURVEY_TABLE_HEADERS.MULTI_COUNTRY.label
            "
            psUiTableCellTemplate
            let-survey
          >
            <div
              class="fw-bold d-flex justify-content-center multi-country-div"
              (click)="redirectToSurvey(survey)"
            >
              <p class="pt-2">{{ survey.country_name }}</p>
              <p class="ms-2 survey-lang-box rounded p-2">
                {{ survey.language_name }}
              </p>
            </div>
          </ng-template>
          <ng-template
            *ngIf="
              header.label ===
              constants.MC_SURVEY_TABLE_HEADERS.FIELDED_DETAILS.label
            "
            psUiTableCellTemplate
            let-survey
          >
            <p class="text-left ps-3" (click)="redirectToSurvey(survey)">
              {{ survey[header.orderKey] }} | {{ survey.completes_required }}
            </p>
          </ng-template>
          <ng-template
            *ngIf="
              header.label ===
              constants.MC_SURVEY_TABLE_HEADERS.CURRENT_CPI.label
            "
            psUiTableCellTemplate
            let-survey
          >
            <div
              class="d-flex justify-content-center ps-3 edit-container"
              *ngIf="!survey?.is_cpi_editable"
            >
              <p class="text-end">
                {{ survey[header.orderKey] }}
              </p>
              <img
                class="ms-2 rounded btn p-0 edit-pen"
                (click)="
                  survey.initial_cpi = survey[header.orderKey];
                  survey.is_cpi_editable = true
                "
                src="../../../../assets/image/edit-pen.png"
                alt="edit pen"
              />
            </div>

            <div
              *ngIf="!!survey?.is_cpi_editable"
              class="edit-button-group d-flex"
            >
              <input
                class="input-text hover-font-color w-50 rounded text-center"
                [ngClass]="{
                  'input-danger-warn':
                    survey[header.orderKey] > MAX_CPI_THRESHOLD
                }"
                type="number"
                min="0"
                [ngModel]="survey[header.orderKey]"
                (ngModelChange)="survey[header.orderKey] = $event"
              />
              <div
                class="d-flex align-items-center justify-content-center action-edit-container ms-2"
              >
                <div
                  class="d-flex align-items-center fa fa-check glyphicon glyphicon-ok p-1 text-primary action-check-button"
                  (click)="updateSurvey(survey, 'cpi')"
                ></div>
                <div
                  class="d-flex align-items-center fa fa-remove glyphicon glyphicon-remove p-1 text-danger action-cancel-button"
                  (click)="
                    survey[header.orderKey] = survey.initial_cpi;
                    survey.is_cpi_editable = false
                  "
                ></div>
              </div>
            </div>
          </ng-template>
          <ng-template
            *ngIf="
              header.label ===
              constants.MC_SURVEY_TABLE_HEADERS.SURVEY_COMPLETES.label
            "
            psUiTableCellTemplate
            let-survey
          >
            <div
              class="edit-container d-flex justify-content-center"
              *ngIf="!survey?.is_completes_editable"
            >
              <p>
                {{ survey[header.orderKey] }}
              </p>
              <img
                class="ms-2 rounded btn p-0 edit-pen"
                (click)="
                  survey.changed_completes = survey[header.orderKey];
                  survey.is_completes_editable = true
                "
                src="../../../../assets/image/edit-pen.png"
                alt="edit pen"
              />
            </div>

            <div
              *ngIf="!!survey?.is_completes_editable"
              class="survey-completes-container d-flex"
            >
              <input
                class="input-text hover-font-color rounded text-center"
                type="number"
                min="0"
                [ngModel]="survey[header.orderKey]"
                (ngModelChange)="survey[header.orderKey] = $event"
                psUiInputRestriction="[0-9]"
              />
              <div
                class="d-flex align-items-center justify-content-center action-edit-container ms-2"
              >
                <div
                  class="d-flex align-items-center fa fa-check glyphicon glyphicon-ok p-1 text-primary action-check-button"
                  (click)="
                    updateSurvey(survey, 'completes');
                    survey.is_completes_editable = false
                  "
                ></div>
                <div
                  class="d-flex align-items-center fa fa-remove glyphicon glyphicon-remove p-1 text-danger action-cancel-button"
                  (click)="
                    survey[header.orderKey] = survey.changed_completes;
                    survey.is_completes_editable = false
                  "
                ></div>
              </div>
            </div>
          </ng-template>
          <ng-template
            *ngIf="
              header.label ===
              constants.MC_SURVEY_TABLE_HEADERS.SURVEY_COUNTRY_PROGRESS.label
            "
            psUiTableCellTemplate
            let-survey
          >
            <div
              class="progress-bar-fielded"
              (click)="redirectToSurvey(survey)"
            >
              <div
                class="progress-bar-fieldedVsGoal"
                role="progressbar"
                [attr.aria-valuenow]="survey.fielded"
                [attr.aria-valuemax]="survey.completes_required"
                [attr.aria-valuemin]="0"
                style="width:{{ progress(survey) }}%"
              ></div>
            </div>
          </ng-template>

          <ng-template
            *ngIf="
              header.label ===
              constants.MC_SURVEY_TABLE_HEADERS.IN_PROGRESS.label
            "
            psUiTableCellTemplate
            let-survey
            let-row="index"
          >
            <div
              class="d-flex justify-content-center"
              (click)="redirectToSurvey(survey)"
            >
              <p class="align-content-center">{{ survey[header.orderKey] }}</p>
              <button
                class="cursor-pointer expandable-btn"
                (click)="
                  getSuppliersById(survey.ps_survey_id, row);
                  $event.stopPropagation()
                "
              >
                <ng-container *ngIf="expandable?.expanded$ | async as state">
                  <i *ngIf="!state.expanded(row)" class="fa fa-caret-down"></i>
                  <i *ngIf="state.expanded(row)" class="fa fa-caret-up"></i>
                </ng-container>
              </button>
            </div>
          </ng-template>

          <ng-template psUiTableCellTemplate let-survey let-row="index">
            <p class="text-center" (click)="redirectToSurvey(survey)">
              {{ survey[header.orderKey] }}
            </p>
          </ng-template>
        </ng-container>
        <ng-template
          psUiTableExpandableContent
          *ngIf="suppliers$ | async as suppliers"
        >
          <div class="supplier-table">
            <ps-ui-table [data]="suppliers">
              <ng-container
                psUiTableColumn
                [sortable]="true"
                [field]="header.orderKey!"
                [textAlignment]="'center'"
                [truncateWord]="false"
                title="{{ header.label }}"
                *ngFor="let header of constants.SUPPLIER_SUB_TABLE_HEADERS"
              >
                <ng-template
                  *ngIf="header.orderKey === 'last_start_date'"
                  psUiTableCellTemplate
                  let-supplier
                  let-row="index"
                >
                  <p
                    class="text-center"
                    [ngClass]="{
                      'ps-2 supplier-name': header.label === 'Supplier Name'
                    }"
                  >
                    {{
                      supplier[header.orderKey]
                        ? (supplier[header.orderKey]
                          | date : 'MM/dd/yyyy h:mma')
                        : '-'
                    }}
                  </p>
                </ng-template>
                <ng-template
                  *ngIf="header.orderKey === 'last_complete_date'"
                  psUiTableCellTemplate
                  let-supplier
                  let-row="index"
                >
                  <p
                    class="text-center"
                    [ngClass]="{
                      'ps-2 supplier-name': header.label === 'Supplier Name'
                    }"
                  >
                    {{
                      supplier[header.orderKey]
                        ? (supplier[header.orderKey]
                          | date : 'MM/dd/yyyy h:mma')
                        : '-'
                    }}
                  </p>
                </ng-template>
                <ng-template psUiTableCellTemplate let-supplier let-row="index">
                  <p
                    class="text-center"
                    [ngClass]="{
                      'ps-2 supplier-name': header.label === 'Supplier Name'
                    }"
                  >
                    {{ supplier[header.orderKey] }}
                  </p>
                </ng-template>
              </ng-container>
            </ps-ui-table>
          </div>
        </ng-template>
      </ng-container>
    </ps-ui-table>
  </div>
  <div *ngIf="!transformedSurveys.length">
    <p class="text-center m-0 text-uppercase text-decor">
      <strong>This is a single country survey</strong>
    </p>
  </div>
</ng-container>
